import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { classNames } from "../../helpers/classNames";
import { elementResize } from "../../helpers";
import Tooltip from "./Tooltip";

// const options = [
//   { id: "email", icon: "fa-regular fa-envelope" },
//   { id: "archive", icon: "fa-regular fa-archive" },
//   { id: "user", icon: "fa-regular fa-user" },
// ];

const ActionBar = ({
  options = [],
  onChange = () => {},
  tooltipPosition = "top",
}) => {
  const div = useRef(null);
  const [selected, setSelected] = useState(options[0]?.id || "");
  const [expanded, setExpanded] = useState(false);
  const [divSize, setDivSize] = useState(0);

  useEffect(() => {
    setSelected(options[0]?.id);
  }, [options?.length]);

  useEffect(() => {
    const cleanup = elementResize(div, setDivSize);
    return () => {
      if (cleanup) cleanup();
    };
  }, [div?.current]);

  const bounceVariant = {
    hidden: { scale: 0.5, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
    exit: {
      scale: 0.5,
      opacity: 0,
      transition: { duration: 0.2 },
    },
  };

  const handleSelect = (id, item) => {
    setSelected(id);
    onChange(id, item);
    setExpanded(false);
  };

  return (
    <motion.div
      key="box"
      {...(expanded
        ? { animate: { width: divSize?.width + 64, opacity: 1 } }
        : {
            animate: { width: 60, opacity: 1 },
          })}
      initial={{ width: 0, opacity: 0 }}
      exit={{ width: 0, opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
      className="bg-white rounded-full flex overflow-hidden"
    >
      <div className="flex items-center gap-1 p-1">
        <Tooltip
          message={options.find((i) => i?.id === selected)?.tooltip}
          position={
            options.find((i) => i?.id === selected)?.tooltipPosition ||
            tooltipPosition
          }
        >
          <button
            type="button"
            className="p-2 text-gray-600 hover:bg-gray-100 transition-all duration-300 rounded-full h-8 w-8 bg-gray-50 flex items-center justify-center"
            onClick={() =>
              handleSelect(
                selected,
                options.find((i) => i?.id === selected)
              )
            }
          >
            <i
              className={classNames(
                "text-sm",
                options.find((i) => i?.id === selected)?.icon
              )}
            ></i>
          </button>
        </Tooltip>

        {/* Hidden Icons (Animated) */}
        <AnimatePresence initial={false}>
          <div className="flex gap-1 items-center" ref={div}>
            {expanded &&
              options
                ?.filter((i) => i?.id !== selected)
                .map((item) => (
                  <Tooltip
                    key={item?.id}
                    message={item?.tooltip}
                    position={item?.tooltipPosition || tooltipPosition}
                  >
                    <motion.button
                      layout
                      className="p-2 text-gray-600 hover:bg-gray-100 transition-[hover] duration-300 rounded-full h-8 w-8 flex items-center justify-center"
                      variants={bounceVariant}
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      onClick={() => handleSelect(item?.id, item)}
                    >
                      <i className={item?.icon}></i>
                    </motion.button>
                  </Tooltip>
                ))}
          </div>
        </AnimatePresence>
      </div>
      {options?.length > 1 && (
        <button
          type="button"
          className="shadow-[0_0_15px_4px_#00000024] w-5 rounded-r-full items-center justify-center opacity-30 hover:opacity-100 transition-all duration-300 ml-auto"
          onClick={() => setExpanded(!expanded)}
        >
          <i className="fa-regular fa-ellipsis-vertical"></i>
        </button>
      )}
    </motion.div>
  );
};

export default ActionBar;
